import { render, staticRenderFns } from "./PopupActionParamForm.vue?vue&type=template&id=72b0c98e"
import script from "./PopupActionParamForm.vue?vue&type=script&lang=js"
export * from "./PopupActionParamForm.vue?vue&type=script&lang=js"
import style0 from "./PopupActionParamForm.vue?vue&type=style&index=0&id=72b0c98e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports